import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ResponsiveLine } from "@nivo/line";
import { groupBy } from "lodash";
import Typography from "@material-ui/core/Typography";

import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import LinePlotSubPlot from "./LinePlotComponent";
import { getSheetData } from "./api";
import clean_cum_ret_data from "./helpers/clean_cum_ret_data.js";
import get_data_for_pos_neg_lines from "./helpers/get_data_for_pos_neg_lines.js";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const LinePlot = () => {
  let location = useLocation();
  let params = useParams();
  let query = useQuery();
  // console.log(params);
  // console.log(location);
  // console.log(query.getAll("sort"));
  const workSheetId = query.get("workSheetId");
  const [sheetData, setSheetData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const hSheetId = "1UUwR9Y4ExPdAWuMFWouhwptRFrw-zjWbQZ_9mx0fh_4";
  const hWorkSheet = "4-cumulative";
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const data = await getSheetData(hSheetId, hWorkSheet);
        console.log(data);
        setSheetData(get_data_for_pos_neg_lines(clean_cum_ret_data(data)));
        setLoading(false);
      } catch (e) {
        setError(true);
      }
    };
    fetchData();
  }, [hSheetId, hWorkSheet]);
  let retRender = [];
  if (sheetData.length !== 0) {
    var grouped = groupBy(sheetData, function (d) {
      return d[0].eDate;
    });

    const lKeys = Object.keys(grouped);
    var sortedKeys = lKeys.sort(function (a, b) {
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      return new Date(b.date) - new Date(a.date);
    });
    const fKeys = lKeys.sort((a, b) => Date.parse(a) - Date.parse(b));

    sortedKeys.forEach((industry) => {
      retRender.push(
        <LinePlotSubPlot
          key={industry}
          sheetData={grouped[industry]}
          category={industry}
        />
      );
    });
  }

  return (
    <div>
      {loading && (
        <div>
          Loading <CircularProgress />
          <Typography variant="h6" gutterBottom style={{ color: "white" }}>
            Loading information for 500 stocks. Takes 30 seconds max
          </Typography>
        </div>
      )}
      {sheetData && (
        <>
          <div
            style={{
              padding: "60px",
              textAlign: "center",
              background: "1abc9c",
              color: "white"
            }}
          >
            <Typography
              variant="h1"
              component="h2"
              gutterBottom
              style={{ color: "white" }}
            >
              Earnings Calendar
            </Typography>

            <Typography variant="h2" gutterBottom style={{ color: "white" }}>
              Stocks in S&P 500 
            </Typography>
            <Typography variant="h4" gutterBottom style={{ color: "white" }}>
              Q1 2021
            </Typography>
            <Typography
              variant="subtitle1"
              gutterBottom
              style={{ color: "white" }}
            >
              Click on each card for Options Volatility / Skew, Stock
              fundamentals.
            </Typography>

            <Typography
              variant="subtitle1"
              gutterBottom
              style={{ color: "white" }}
            >
              If you'd like to visualize your watchlist, drop in a note to
              contact@perceptron.solutions. Note: This report is based on April
              14, 2021 data
            </Typography>
          </div>
          <Grid container spacing={100} direction={"row"}>
            {retRender}
          </Grid>
        </>
      )}
    </div>
  );
};

export default LinePlot;
